module.exports = __webpack_public_path__ + "img/Weapon_247.51c56ebb.png";